export const urlApi = 'https://reportesicontec.azurewebsites.net/'

export const AuthAzure = urlApi+'api/AuthAzure'
export const creaPermisos = urlApi+'api/CreaPermisos'
export const obtenerReportePorId=urlApi+'api/ObtenerReportePorId/'
export const obtenerUsuarios= urlApi+'api/ObtenerUsuarios/'
export const eliminaPermisos = urlApi+'api/EliminaPermisos/'
export const obtenertodospermisos =urlApi+'api/obtenertodospermisos/'
export const creaReporte = urlApi+'api/CreaReporte'
export const actualizaReporte = urlApi+'api/ActualizaReporte/'
export const eliminaReporte = urlApi+'api/EliminaReporte/'
export const obtenerCorreoPorId= urlApi+'api/ObtenerId?correo='
export const creaUsuario = urlApi+'api/CreaUsuario'
export const eliminaUsuario = urlApi+'api/EliminaUsuario/'